import "./CertificateGroupingWIthRatingFinalReview.scss";
import CertificateWithRatingFinalReview from "../../features/ServiceCertificateGrouping/FinalApprovalCertificate/CertificateWithRating/CertificateWithRatingFinalReview";

const CertificateGroupingWIthRatingFinalReview = () => {
  return (
    <div className="analytics-page">
       <CertificateWithRatingFinalReview/> 
    </div>
  );
};

export default CertificateGroupingWIthRatingFinalReview;
